<template>
    <div>
        <v-img 
            src="@/assets/librototal.png"
            @click="getContents"
            class="grey lighten-2"
            width="100%"
            >
        </v-img>
    </div>
</template>
<script>
export default {

    components:{  },

    data: () => ({}),

    mounted() {

    },

    computed: {     
     // window.open(to.meta.redirect, "_blank");
    


    },


   //metodos
    methods: {
           getContents() {
            let url = "https://www.ellibrototal.com/ltotal/"
            window.open(url, "_blank")
        }



    }

  }
</script>



<style scoped>


</style>

